export default "__VITE_ASSET__Gy70tWJT__"